/* ============================================================
   SDCOME 2026-10-18 - Free Gifts tab + slide-down panel (#sdgt)
   Markup and styles: snippets/sdcome-finder-tab.liquid.
   Recorded in snippets/sdcome-manifest.liquid (C22).

   Data: the offers are read from the Gift Box app (Digismoothie), the
   same public list its own popup uses:
     https://giftbox.digismoothie.app/api/offers?shop=<shop>.myshopify.com
   Each offer names its gift product (shopify_product_handle, image,
   ghost_product.parent_title); the gift's value comes from the store's
   own /products/<handle>.js (compare-at price when higher, else price),
   as the app shows it. Nothing about the offers is typed in the theme.
   Loaded on the first open (prefetched on tab hover / focus), kept in
   sessionStorage for 10 minutes (complete results only), 8 second timeout.
   Fixes from the UX and code reviews of 2026-10-18 are marked
   "SDCOME review 2026-10-18" or described in the comments next to them.
   Headlines: the tier ("$750 to $949.99", "$950 or more", "$199 or
   more") is taken from the offer's own wording by rule; if no amount is
   found the app's words are shown, cleaned. The shared condition note is
   shown once as "T&C" (numbered "T&C 1", "T&C 2" only when offers carry
   different notes; was "Terms 1"; SDCOME 2026-10-18 (11) and (12), Ewout).
   Behaviour: button with aria-expanded; opening moves focus to the panel
   heading; Close and Esc (when focus is in the panel, the tab row or
   nowhere) close it and return focus to the tab. Never opens
   by itself. If the app list cannot be read, an error with Try again.
   Tracking hooks: data-sdgt-track, data-sdgt-offer, data-sdgt-pos;
   document events sdgt:open / sdgt:close; dataLayer pushes
   sd_gift_tab_open and sd_gift_offer_click (dataLayer when it exists).
   SDCOME 2026-10-19 (C26): both events also go to Clarity and Shopify
   customer events (GA4 pixel) through window.sdTrack; see push() and
   offerClick().
   SDCOME 2026-10-19 (C23): shared offer reader. window.sdGiftOffers()
   returns the same parsed offer list (one parser, one cache) for the
   detector finder's add-to-cart panel (assets/sdcome-detector-finder.js).
   Each item now also carries lo / hi (the tier's dollar range read from
   the app's wording, hi null for "or more") and det (true for offers on
   a new metal detector). Cache key bumped to sdgt:v3 for the new fields.
   C23 review: bundle = the number at the end of the offer's name ("FREE
   Metal Detecting Bundle 3" -> 3), matched by the finder to the
   free-bundle-0N collection of the detector before the price range.
   Cache key sdgt:v4.
   ============================================================ */
(function () {
  var wrap = document.getElementById('sdgt');
  if (!wrap || wrap.getAttribute('data-sd-ready')) return;
  wrap.setAttribute('data-sd-ready', '1');

  var panel = document.getElementById('sdgt-panel');
  var tab = document.getElementById('sdgt-tab');
  var title = document.getElementById('sdgt-title');
  var slot = panel && panel.querySelector('.sdgt-slot');
  var status = panel && panel.querySelector('[data-sdgt-status]');
  if (!panel || !tab || !title || !slot) return;

  var SHOP = wrap.getAttribute('data-sdgt-shop') || (window.Shopify && window.Shopify.shop) || '';
  var API = 'https://giftbox.digismoothie.app/api/offers?shop=' + encodeURIComponent(SHOP);
  var CACHE_KEY = 'sdgt:v4', TTL = 10 * 60 * 1000, TIMEOUT = 8000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = 'idle', pending = null, closeTimer = null, offersShown = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    var c = Math.round(v * 100);
    return '$' + (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function safeHandle(h) { return /^[a-z0-9][a-z0-9-]*$/i.test(h || '') ? h : ''; }
  function safeImg(u) { return /^https:\/\/cdn\.shopify\.com\//.test(u || '') ? u : ''; }
  function imgSized(u) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=264'; }

  /* SDCOME review 2026-10-18: the timeout covers the body read too, and a
     404 is told apart from a network error */
  function getJSON(url, creds) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () { if (ctl) ctl.abort(); reject(new Error('timeout')); }, TIMEOUT);
    });
    var opts = { credentials: creds || 'omit' };
    if (ctl) opts.signal = ctl.signal;
    var req = fetch(url, opts).then(function (r) {
      if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
    return Promise.race([req, timeout]).then(function (v) { clearTimeout(timer); return v; },
      function (e) { clearTimeout(timer); throw e; });
  }

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < TTL && Array.isArray(c.items) && c.items.every(validItem)) return c.items;
    } catch (e) { /* ignore */ }
    return null;
  }
  function writeCache(items) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { /* ignore */ }
  }

  function validItem(it) {
    return it && typeof it === 'object' && safeHandle(it.handle) === it.handle && typeof it.tier === 'string' &&
      typeof it.name === 'string' && (it.image === '' || safeImg(it.image) === it.image) &&
      (it.value === null || (typeof it.value === 'number' && it.value > 0)) &&
      (it.lo === null || typeof it.lo === 'number') && (it.hi === null || typeof it.hi === 'number') && typeof it.det === 'boolean' &&
      (it.bundle === null || typeof it.bundle === 'number');
  }

  /* active offers only, in the app's order */
  function active(o) {
    if (!o || o.enabled === false || (o.status && o.status !== 'ENABLED') || o.can_activate === false) return false;
    var now = Date.now();
    if (o.start_datetime && Date.parse(o.start_datetime) > now) return false;
    if (o.end_datetime && Date.parse(o.end_datetime) < now) return false;
    var c = o.available_in_countries;
    var country = window.Shopify && window.Shopify.country;
    if (Array.isArray(c) && c.length && country && c.indexOf(country) < 0) return false;
    return !!safeHandle(o.shopify_product_handle);
  }

  /* headline from the app's own wording, by rule */
  var AMT = '\\$\\s?([\\d,]+(?:\\.\\d{2})?)';
  function tidyAmt(a) { var v = Number(String(a).replace(/,/g, '')); return isFinite(v) ? money(v) : '$' + a; }
  /* SDCOME 2026-10-19 (C23): the tier's numbers, for the finder panel */
  function amtNum(a) { var v = Number(String(a).replace(/,/g, '')); return isFinite(v) ? v : null; }
  var RANGE = new RegExp(AMT + '\\s*(?:to|and|-|\u2013|\u2014)\\s*' + AMT, 'i');
  var MIN = new RegExp(AMT + '\\s*(?:or more|\\+|and up|and over|or over|or higher)', 'i');
  var SPEND = new RegExp('(?:spend|over|at least)\\s*' + AMT, 'i');
  var NO_DET = /(?:exclud\w*|not\s+(?:valid\s+)?(?:on|with|for))\s+(?:all\s+|any\s+)?metal detector/i;
  function derive(t, s) {
    var r, tier = '', eyebrow = '', src = '', lo = null, hi = null;
    [t, s].some(function (x) {
      if (!x) return false;
      if ((r = RANGE.exec(x))) { tier = tidyAmt(r[1]) + ' to ' + tidyAmt(r[2]); lo = amtNum(r[1]); hi = amtNum(r[2]); }
      else if ((r = MIN.exec(x))) { tier = tidyAmt(r[1]) + ' or more'; lo = amtNum(r[1]); }
      else if ((r = SPEND.exec(x))) { tier = tidyAmt(r[1]) + ' or more'; lo = amtNum(r[1]); }
      if (tier) src = x;
      return !!tier;
    });
    var noDet = NO_DET.test(src);
    if (tier && /metal detector/i.test(src) && !noDet) eyebrow = 'With a new metal detector';
    else if (tier && noDet) eyebrow = 'Accessories, not detectors';
    else if (tier) eyebrow = 'Order total';
    if (!tier) {
      tier = (t || s).replace(/^(?:and\s+)?(?:receive|get)\s+(?:an?\s+)?/i, '').replace(/^to\s+get\s+(?:an?\s+)?/i, '')
        .replace(/\s*terms and conditions apply\.?$/i, '').replace(/!/g, '').replace(/\s+/g, ' ').trim();
      tier = tier.charAt(0).toUpperCase() + tier.slice(1);
      if (!tier || tier.length > 70) tier = 'Free gift';
      eyebrow = 'Bonus gift';
    }
    return { eyebrow: eyebrow, tier: tier, lo: lo, hi: hi };
  }

  function plain(v) {
    var s = String(v == null ? '' : v);
    if (/[<&]/.test(s)) {
      try { s = new DOMParser().parseFromString(s, 'text/html').body.textContent || ''; } catch (e) { s = s.replace(/<[^>]*>/g, ''); }
    }
    return s.replace(/\s+/g, ' ').trim();
  }

  function toItem(o) {
    var thr = o.threshold != null && o.threshold !== '' ? money(o.threshold) : '';
    var t = plain(o.title_empty_cart);
    if (t.length < 4) t = plain(o.title_condition_not_met);
    if (t.length < 4) t = ''; /* placeholder titles such as "x" */
    if (/REMAININGSPEND/.test(t) && !thr) t = '';
    t = t.replace(/REMAININGSPEND/g, thr);
    var s = plain(o.subtitle_condition_not_met).replace(/REMAININGSPEND/g, thr);
    var d = derive(t, s);
    /* the subtitle is a condition note only when the title carries the offer
       and the subtitle is not just the second half of the sentence */
    var note = t && s && !/^(?:and|to|or)\b/i.test(s) ? s : '';
    var g = o.ghost_product || {};
    return {
      id: String(o.id || ''), eyebrow: d.eyebrow, tier: d.tier, note: note,
      lo: d.lo, hi: d.hi, det: d.eyebrow === 'With a new metal detector',
      bundle: (function (m) { return m ? Number(m[1]) : null; })(/bundle\s*0*(\d+)\s*$/i.exec(String(o.name || ''))),
      handle: safeHandle(o.shopify_product_handle),
      name: String(g.parent_title || o.shopify_product_name || '').trim(),
      image: safeImg(o.shopify_product_image_url),
      variant: Array.isArray(o.shopify_product_variants) ? Number(o.shopify_product_variants[0]) || 0 : 0,
      value: null
    };
  }

  /* gift value as the app shows it: compare-at when higher, else price, of
     the offer's variant (first variant as fallback). A 404 means the gift
     product is not published: that offer is left out. Any other failure
     fails the whole load, so a partial list is never shown or cached. */
  function addValues(items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return Promise.all(items.map(function (it) {
      return getJSON(root + 'products/' + it.handle + '.js', 'same-origin').then(function (p) {
        var vs = Array.isArray(p.variants) ? p.variants : [];
        var v = vs.filter(function (x) { return Number(x.id) === it.variant; })[0] || vs[0] || p;
        var price = Number(v.price), cmp = Number(v.compare_at_price);
        var cents = cmp > price ? cmp : price;
        it.value = cents > 0 ? cents / 100 : null;
        if (!it.name) it.name = plain(p.title);
        if (!it.image && p.featured_image) it.image = safeImg(String(p.featured_image).replace(/^\/\//, 'https://'));
        delete it.variant;
        return it;
      }, function (e) { if (e && e.status === 404) return null; throw e; });
    })).then(function (list) { return list.filter(Boolean); });
  }

  function load() {
    if (pending) return pending;
    var cached = readCache();
    if (cached) return (pending = Promise.resolve(cached));
    pending = getJSON(API).then(function (j) {
      if (!j || !Array.isArray(j.offers)) throw new Error('unexpected offer data');
      return addValues(j.offers.filter(active).map(toItem));
    }).then(function (items) { writeCache(items); return items; });
    pending.catch(function () { pending = null; });
    return pending;
  }
  /* SDCOME 2026-10-19 (C23): shared with the detector finder panel */
  window.sdGiftOffers = function () { return load(); };

  function skeleton() {
    slot.setAttribute('aria-busy', 'true');
    slot.innerHTML = '<div class="sdgt-skel" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div><span class="sdgt-vh">Loading gift offers</span>';
  }
  function say(text) { if (status) { status.textContent = ''; setTimeout(function () { status.textContent = text; }, 50); } }
  function message(html, text) {
    slot.setAttribute('aria-busy', 'false');
    slot.innerHTML = '<div class="sdgt-msg">' + html + '</div>';
    say(text);
  }

  function render(items) {
    slot.setAttribute('aria-busy', 'false');
    offersShown = items;
    if (!items.length) { message('No free gift offers are running right now. Check back soon.', 'No free gift offers right now.'); return; }
    var notes = [], feat = '', extra = '';
    /* SDCOME 2026-10-18 (12): one shared note reads "T&C" with no number (Ewout) */
    items.forEach(function (it) { if (it.note && notes.indexOf(it.note) < 0) notes.push(it.note); });
    function num(k) { return notes.length > 1 ? ' ' + (k + 1) : ''; }
    items.forEach(function (it, i) {
      var fn = '';
      if (it.note) {
        var k = notes.indexOf(it.note);
        fn = '<span class="sdgt-fn"><a href="#sdgt-n' + (k + 1) + '"><span aria-hidden="true">T&amp;C' + num(k) + '</span><span class="sdgt-vh">Terms and conditions' + num(k) + '</span></a></span>';
      }
      var big = (it.value || 0) >= 20;
      var img = it.image
        ? '<img src="' + esc(imgSized(it.image)) + '" alt="" width="132" height="132" loading="lazy" decoding="async">'
        : '';
      var card = '<li class="sdgt-card' + (big ? '' : ' sdgt-card--row') + '" data-sdgt-offer="' + esc(it.id) + '" data-sdgt-pos="' + (i + 1) + '">' +
        '<h3 class="sdgt-tier"><span class="sdgt-eyebrow">' + esc(it.eyebrow) + '<span class="sdgt-vh">: </span></span>' + esc(it.tier) + '</h3>' +
        '<span class="sdgt-img">' + img + '</span>' +
        '<p class="sdgt-name"><a href="/products/' + esc(it.handle) + '" data-sdgt-track="gift_offer_click" data-sdgt-handle="' + esc(it.handle) + '">' + esc(it.name) + '</a></p>' +
        '<p class="sdgt-val">' + (it.value ? '<s><span class="sdgt-vh">Regular price </span>' + esc(money(it.value)) + '</s>' : '') + '<span class="sdgt-free">FREE</span>' + fn + '</p>' +
        '</li>';
      if (big) feat += card; else extra += card;
    });
    slot.innerHTML =
      '<div class="sdgt-body' + (extra && feat ? '' : ' no-extra') + '">' +
        (feat ? '<ul class="sdgt-feat" role="list">' + feat + '</ul>' : '') +
        (extra ? '<ul class="sdgt-extra" role="list">' + extra + '</ul>' : '') +
      '</div>' +
      (notes.length ? '<div class="sdgt-terms">' + notes.map(function (n, i) {
        return '<p id="sdgt-n' + (i + 1) + '"><strong>T&amp;C' + num(i) + ':</strong> ' + esc(n) + '</p>';
      }).join('') + '</div>' : '');
    say(items.length === 1 ? '1 gift offer.' : items.length + ' gift offers.');
    Array.prototype.forEach.call(slot.querySelectorAll('.sdgt-img img'), function (im) {
      function ok() { if (im.parentNode) im.parentNode.classList.add('is-loaded'); }
      if (im.complete && im.naturalWidth) ok();
      im.addEventListener('load', ok);
      im.addEventListener('error', function () { im.remove(); });
    });
  }

  function fill() {
    if (state === 'done' || state === 'loading') return;
    state = 'loading';
    skeleton();
    load().then(function (items) { render(items); state = 'done'; }).catch(function () {
      state = 'error';
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) { /* ignore */ }
      message('The gift offers did not load. <button type="button" data-sdgt-retry>Try again</button>', 'The gift offers did not load.');
    });
  }

  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { /* old browsers */ }
  }
  /* SDCOME 2026-10-19 (C26, Ewout): through window.sdTrack (snippets/
     sdcome-finder-tab.liquid), which also sends the event to Clarity and to
     Shopify customer events for the GA4 pixel. later = true for the offer
     link, which leaves the page. Without sdTrack: dataLayer only, as before. */
  function push(obj, later) {
    if (typeof window.sdTrack === 'function') {
      var d = {}, k;
      for (k in obj) if (k !== 'event' && Object.prototype.hasOwnProperty.call(obj, k)) d[k] = obj[k];
      try { window.sdTrack(obj.event, d, later); return; } catch (e) { /* fall back below */ }
    }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(obj);
  }
  function isOpen() { return tab.getAttribute('aria-expanded') === 'true'; }

  function open() {
    clearTimeout(closeTimer);
    panel.hidden = false;
    void panel.offsetHeight; /* start the slide from 0 */
    wrap.classList.add('is-open');
    tab.setAttribute('aria-expanded', 'true');
    fill();
    try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); }
    emit('sdgt:open', { source: 'tab', page_type: wrap.getAttribute('data-sdgt-page') || '' });
    push({ event: 'sd_gift_tab_open', page_type: wrap.getAttribute('data-sdgt-page') || '' });
  }
  function close(source, returnFocus) {
    if (!isOpen()) return;
    wrap.classList.remove('is-open');
    tab.setAttribute('aria-expanded', 'false');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { if (!isOpen()) panel.hidden = true; }, reduce ? 0 : 280);
    if (returnFocus) tab.focus();
    emit('sdgt:close', { source: source });
  }

  tab.addEventListener('click', function () { if (isOpen()) close('tab', false); else open(); });
  function prefetch() { load().catch(function () {}); }
  tab.addEventListener('pointerenter', prefetch, { once: true });
  tab.addEventListener('focus', prefetch, { once: true });
  panel.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-sdgt-close]')) { close('close', true); return; }
    if (t.closest('[data-sdgt-retry]')) {
      state = 'idle'; pending = null; fill();
      try { title.focus({ preventScroll: true }); } catch (err) { title.focus(); }
      return;
    }
    offerClick(e);
  });
  /* SDCOME 2026-10-19 (C26 review): offer click; sent at once when it opens a
     new tab (Ctrl/Cmd/Shift, middle button, target), else on the next page */
  function offerClick(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[data-sdgt-track="gift_offer_click"]') : null;
    if (!a) return;
    var li = a.closest('[data-sdgt-offer]');
    var tg = a.getAttribute('target');
    var newTab = e.type === 'auxclick' || e.ctrlKey || e.metaKey || e.shiftKey || (tg && tg !== '_self');
    push({ event: 'sd_gift_offer_click', offer_id: li ? li.getAttribute('data-sdgt-offer') : '',
           gift_handle: a.getAttribute('data-sdgt-handle') || '', position: li ? Number(li.getAttribute('data-sdgt-pos')) : 0,
           page_type: wrap.getAttribute('data-sdgt-page') || '', link_page: location.pathname }, !newTab);
  }
  panel.addEventListener('auxclick', function (e) { if (e.button === 1) offerClick(e); });
  document.addEventListener('keydown', function (e) {
    if ((e.key !== 'Escape' && e.key !== 'Esc') || e.defaultPrevented || !isOpen()) return;
    var a = document.activeElement;
    if (a && a !== document.body && !wrap.contains(a)) return; /* another widget has focus */
    close('esc', true);
  });
  /* back/forward cache: always come back closed */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && isOpen()) { wrap.classList.remove('is-open'); tab.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
  });
})();
